import type { FormEvent } from "react";

/**
 * Runs the browser’s built-in constraint validation on the form.
 * If anything is invalid: calls `preventDefault`, shows the native validation
 * tooltip (`reportValidity`), and returns `false`.
 * If everything passes: returns `true` — you should then call `e.preventDefault()`
 * yourself before async submit logic.
 */
export function checkNativeFormValidity(e: FormEvent<HTMLFormElement>): boolean {
  const form = e.currentTarget;
  if (!form.checkValidity()) {
    e.preventDefault();
    form.reportValidity();
    return false;
  }
  return true;
}
